export default __webpack_public_path__ + "static/media/480_store05-en-web.6893cf72.png";